import React, { useRef } from 'react'
import { css, CSSObject, SerializedStyles } from '@emotion/core'

type RadioButtonProps<T> = {
  value?: T
  checked: boolean
  id: string
  name?: string
  item: {
    value: T
    label: string
  }
  onChange: (event: React.ChangeEvent<HTMLInputElement & { value: T }>) => void
  style?: {
    radioSize?: number
    labelMargin?: number
  }
  itemCss?: CSSObject | SerializedStyles
  labelCss?: CSSObject | SerializedStyles
  disabled?: boolean
}

export const RadioButton = <T,>({ id, item, name, itemCss, labelCss, checked, onChange, style, disabled = false }: RadioButtonProps<T>) => {
  const hiddenInputRef = useRef<HTMLInputElement>(null)

  return (
    <div
      css={[
        radioItemStyle,
        itemCss,
        disabled && {
          cursor: 'not-allowed',
        },
      ]}
      onClick={() => {
        if (disabled) return
        hiddenInputRef.current?.click()
      }}
      defaultValue={item.value as unknown as any}
    >
      <input
        ref={hiddenInputRef}
        type="radio"
        style={{ display: 'none' }}
        checked={checked}
        onChange={onChange}
        id={id}
        name={name}
        value={item?.value as unknown as any}
        disabled={disabled}
      />
      <img
        width={style?.radioSize || 26}
        height={style?.radioSize || 26}
        style={{ marginRight: style?.labelMargin === undefined ? 14 : style.labelMargin }}
        alt="radio"
        src={require(`@/static/images/radio_${disabled ? 'disabled' : checked ? 'on' : 'off'}.svg`)}
      />
      <label htmlFor={id} css={[radioLabelStyle, labelCss, disabled && radioLabelDisabledStyle]}>
        {item.label}
      </label>
    </div>
  )
}
const radioItemStyle = css({
  display: 'flex',
  alignItems: 'center',
  color: '#272727',
  fontSize: 14,
  cursor: 'pointer',
  float: 'left',
})

const radioLabelStyle = css({
  display: 'block',
  color: '#272727',
  cursor: 'pointer',
})

/** Figma: 選択不可はラベルを #CCC、背景帯は付けない */
const radioLabelDisabledStyle = css({
  color: '#CCCCCC',
  cursor: 'not-allowed',
})
